import { render } from "./list-options-delete-modal.vue?vue&type=template&id=1dddbfc6&ts=true"
import script from "./list-options-delete-modal.vue?vue&type=script&lang=ts"
export * from "./list-options-delete-modal.vue?vue&type=script&lang=ts"

import "./list-options-delete-modal.vue?vue&type=style&index=0&id=1dddbfc6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__